export default __webpack_public_path__ + "static/media/grocery9.21ac0980.jpeg";